export const MARKET_NODES = ['共振转势', '冰点'];

export const DRAGON_NODES = [
  '双一字预承接',
  '二波补涨',
  '预平高度',
  '预破高度',
  '预爆高低切',
  '龙头跌停',
  '龙头二连跌停',
  '龙头余温',
  '龙头破30日线',
  '断板/首阴',
  '龙头双爆'
];

export const ALL_REVIEW_NODES = [...MARKET_NODES, ...DRAGON_NODES];

export const INDEX_TREND_OPTIONS = ['顺指数', '逆指数'];

export function splitNodeTokens(raw) {
  const text = String(raw || '').trim();
  if (!text) return [];
  return text
    .split(/[,，、]/)
    .map((s) => s.trim())
    .filter(Boolean);
}

export function parseNodeStatusForEdit(raw) {
  const tokens = splitNodeTokens(raw);
  return tokens.filter((t) => ALL_REVIEW_NODES.includes(t));
}

export function formatNodeStatus(nodes) {
  return (nodes || [])
    .filter((n) => ALL_REVIEW_NODES.includes(n))
    .join('，');
}

export function getNodeKind(node) {
  if (MARKET_NODES.includes(node)) return 'market';
  if (DRAGON_NODES.includes(node)) return 'dragon';
  return 'legacy';
}

export function hasDragonNode(nodes) {
  return (nodes || []).some((n) => DRAGON_NODES.includes(n));
}

export function getNodeClass(node) {
  const kind = getNodeKind(node);
  if (kind === 'dragon') return 'node-text--dragon';
  return 'node-text--market';
}

export function getStarClass(node) {
  const kind = getNodeKind(node);
  if (kind === 'dragon') return 'node-star--dragon';
  return 'node-star--market';
}

export function buildColoredStars(nodes) {
  return (nodes || []).map((node) => ({
    node,
    class: getStarClass(node)
  }));
}
